import { useTranslation } from 'react-i18next';
import { parseCancellationPreset } from '../helpers/cancellationReason';

export default function TimeslotCancelledBanner({ reason }: { reason: string }) {
    const { t } = useTranslation();
    const preset = parseCancellationPreset(reason);

    return (
        <div className="fireknife-timeslot-cancelled-banner" role="alert">
            <strong className="fireknife-timeslot-cancelled-banner__title">
                {preset ? preset.title : t('timeslots.cancelledTitle')}
            </strong>
            {preset ? preset.subtext : reason}
        </div>
    );
}
